import ExpensesDetail from './ExpensesDetail';

export default ExpensesDetail;